import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default function getComposition(context, customerId, compositionId) {
  let compositions = getCompositionsStore(context, customerId);
  if (compositions) {
    return compositions.findBy({ id: compositionId });
  }
}
